/* eslint-disable */
import ReportGamePerformanceList from './report-game-performance.list';

export default {
  list: ReportGamePerformanceList,
};
